export const CTA_DATA = {
    title: 'Коли сили об’єднуються<br />народжується надія',
    description:
        'Ми віримо в силу спільноти, єдності і в те, що разом ми здатні повертати світло туди, де його було втрачено. Запрошуємо вас стати частиною історії зцілення та перемоги!',
};
